module.exports = __webpack_public_path__ + "static/media/kalimati.e2285a72.woff2";